import VolunteerActivismOutlinedIcon from '@mui/icons-material/VolunteerActivismOutlined';
import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';
import ImageSearchOutlinedIcon from '@mui/icons-material/ImageSearchOutlined';

const features = [
  {
    icon: <VolunteerActivismOutlinedIcon className="text-5xl  " />,
    title: "Trusted by 500+ Clients",
    description:
      "Homeowners across Gujarat choose Boost Solar for reliable service and transparent pricing.",
  },
  {
    icon: <ConstructionOutlinedIcon className="text-4xl" />,
    title: "Save on Energy Bills",
    description:
      "Switch to solar and start saving from day one—lower bills, higher returns.",
  },
  {
    icon: <ImageSearchOutlinedIcon className="text-4xl " />,
    title: "Easy Installation",
    description:
      "Hassle-Free Installation, We offer the best value solar solutions in Kutch.",
  },
];

const FeatureCard = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {features.map((feature, index) => (
        <div
          key={index}
          className=" bg-white border border-gray-200 shadow-lg rounded-xl p-6 text-center hover:shadow-xl transition-shadow duration-300"
        >
            <div className="flex justify-center items-center w-16 h-16 mx-auto rounded-full text-primary bg-opsecondary border">
            {feature.icon}
            </div>
          <h3 className="text-xl font-semibold text-primary mb-2 mt-1">
            {feature.title}
          </h3>
          <p className="text-gray-700">{feature.description}</p>
        </div>
      ))}
    </div>
  );
};

export default FeatureCard;
